import { render, staticRenderFns } from "./shenghuo.vue?vue&type=template&id=35bfe753&scoped=true&"
import script from "./shenghuo.vue?vue&type=script&lang=js&"
export * from "./shenghuo.vue?vue&type=script&lang=js&"
import style0 from "./shenghuo.vue?vue&type=style&index=0&id=35bfe753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bfe753",
  null
  
)

export default component.exports